import * as React from 'react';
const selectFields = [
    'CnSelect',
    'CnCascaderSelect',
    'CnAsyncSelect',
    'CnDepartmentSelect',
    'CnEmployeeSelect',
];
// 从children中找出快捷筛选的项
export const splitFilter = (filter) => {
    if (!filter)
        return [null, null];
    const normalFilterChild = [];
    const quickFilterChild = [];
    filter.forEach((child) => {
        if (React.isValidElement(child)) {
            // 兼容 PC => H5 一码多端情况，额外设定 mobileProps
            const childProps = (child.props || {});
            const isQuickFilter = childProps.quick || childProps.mobileProps?.quick;
            if (isQuickFilter) {
                if (child.props.children?.type?.displayName === 'CnSelector') {
                    quickFilterChild.push(cnSelectorQuickItemRender(child));
                }
                else {
                    quickFilterChild.push(cnSelectQuickItemRender(child));
                }
            }
            else {
                normalFilterChild.push(child);
            }
        }
    });
    return [
        quickFilterChild.map((item, i) => (React.createElement("div", { key: `${Date.now() + i}`, className: "cn-ui-m-filter-quick-filter-wrapper" },
            React.createElement("div", { className: "cn-ui-m-filter-quick-filter", style: item?.props?.style }, item)))),
        normalFilterChild,
    ];
};
const cnSelectQuickItemRender = (child) => {
    // CnSelect 实例
    const itemChildren = child.props.children;
    return React.cloneElement(child, {
        name: child.props.name,
        decorator: [],
        children: React.cloneElement(itemChildren, {
            placeholder: child.props.label || child.props.title,
            insideFilter: true,
        }),
    });
};
const cnSelectorQuickItemRender = (child) => {
    const itemChildren = child.props.children;
    return React.cloneElement(child, {
        name: child.props.name,
        decorator: [],
        children: React.cloneElement(itemChildren, {
            cnBoxProps: { wrap: false },
        }),
    });
};
